import { Box, useTheme } from '@mui/material';
import Switch from '@mui/material/Switch';
import * as React from 'react';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { flexCenter } from '../commonUI/cssClasses';
import TooltipPopup from '../commonUI/tooltips/TooltipPopup';
import MaskSettingsPopup from './MaskSettingsPopup';
import { selectShowMasks, setShowMasks } from './imageSlice';

const MaskToggle: React.FC = () => {
  const dispatch = useAppDispatch();
  const showMasks = useAppSelector(selectShowMasks);
  const theme = useTheme();

  const handleShowMasksClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    event.stopPropagation();
    dispatch(setShowMasks(event.target.checked));
  };

  return (
    <TooltipPopup
      popupComponent={<MaskSettingsPopup />}
      colorScheme='dark'
      margin={`0 ${theme.recentScansPage.spacing} 0 0`}
      placement='right'
    >
      <Box sx={{ ...flexCenter }}>
        <Switch
          checked={showMasks}
          onChange={handleShowMasksClick}
          inputProps={{ 'aria-label': 'Mask Toggle Switch' }}
        />
      </Box>
    </TooltipPopup>
  );
};

export default MaskToggle;
